import { JSM_BASE_URL } from '../settings';
import { type FieldValue, type JsmErrorResponseDto, type JsmUploadResponseDto } from '../types';
import { JsmClient } from '../utilities';
import { mapJsmErrorResponseDtoToFormError } from './mapJsmErrorResponseDtoToFormError';

export const createJsmUpload = async (
  files: File[],
  dataKey: string,
  onProgress?: (progress: number) => void,
): Promise<FieldValue[]> => {
  const jsmClient = new JsmClient(JSM_BASE_URL);
  const url = `${encodeURIComponent(dataKey)}/upload`;

  try {
    console.debug('createJsmUpload: Files to upload:', files);
    const response = await jsmClient.uploadFiles(url, files, onProgress);
    return mapJsmUploadResponseDtoToFieldValues(response as JsmUploadResponseDto);
  } catch (error: any) {
    console.error('createJsmUpload: JSM error:', JSON.parse(JSON.stringify(error)));
    const jsmError = error.responseBody as JsmErrorResponseDto;
    throw mapJsmErrorResponseDtoToFormError(jsmError);
  }
};

const mapJsmUploadResponseDtoToFieldValues = (response: JsmUploadResponseDto): FieldValue[] => {
  return response.map(file => file.temporaryAttachmentId);
};
